module.exports = __webpack_public_path__ + "static/media/icon_linkedin.cb43d5e8.svg";